






































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import moment from 'moment'
import { PASS_COLUMNS, REVIEW_COLUMNS } from '../config/columns'
import { CATEGORIES, ALL_GROUPS } from '../config/'
import { BUSINESS_SOURCE_DATA, USER_GROUPS } from '@/service/constant'
import { getMyResource, editResources, publishResource } from '../api/'
import { getToken, getMd5, uploadAliyunOss, downloadHost } from '@/service/aliyunOssUpload'
import { Divider } from 'ant-design-vue'

@Component
export default class ContentManage extends Vue {
  private isUploader = false
  private uploading = false
  private uploadedFiles: string[] = []
  private get groups() {
    return this.$store.state[USER_GROUPS]
  }
  private passColumns = PASS_COLUMNS
  private reviewColumns = REVIEW_COLUMNS
  private passDataSource = []
  private reviewDataSource = []
  private visible = false
  private form: any
  private layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 }
  }
  private categories = CATEGORIES
  private sourceDataTypes: any[] = []
  private resources: any = []

  private files: any = []

  private passPagination = {
    current: 1,
    pageSize: 50,
    total: 0
  }

  private reviewPagination = {
    current: 1,
    pageSize: 50,
    total: 0
  }

  private get sourceData() {
    return this.$store.state[BUSINESS_SOURCE_DATA]
  }

  beforeCreate() {
    console.log('init form')
    ;(this as any).form = this.$form.createForm(this)
  }

  mounted() {
    this.isUploader = this.groups.includes(ALL_GROUPS[4].id)
    this.renderPassDataSource(1)
    this.renderReviewDataSource(1)
  }

  async renderPassDataSource(page: number) {
    const { pageSize } = this.passPagination
    const res = await getMyResource('finish', page, pageSize)
    const { list, total } = res

    this.passDataSource = list
    this.passPagination.total = total
  }

  handlePassPaginationChange(pagination) {
    const { current } = pagination

    this.passPagination.current = current
    this.renderPassDataSource(current)
  }

  async renderReviewDataSource(page: number) {
    const { pageSize } = this.reviewPagination
    const res = await getMyResource('running', page, pageSize)
    const { list, total } = res

    this.reviewDataSource = list
    this.reviewPagination.total = total
  }

  handleReviewPaginationChange(pagination) {
    const { current } = pagination

    this.reviewPagination.current = current
    this.renderReviewDataSource(current)
  }

  async markPublish(record) {
    const id = record.relate_id
    const res = await publishResource(id)
    this.renderPassDataSource(1)
  }

  handleBusinessTypeChange(value) {
    const source = this.sourceData[`${value}`]
    this.sourceDataTypes = Object.keys(source).map((item) => {
      return {
        label: source[item],
        value: item
      }
    })
  }

  showUploadModal() {
    this.visible = true
    setTimeout(() => {
      this.form.setFieldsValue({
        publish: moment(new Date(), 'YYYY-MM-DD')
      })
    }, 0)
  }

  normFile(e) {
    if (Array.isArray(e)) {
      return e
    }
    return e && e.fileList
  }

  beforeUpload(file: any) {
    if (this.uploadingList === 0) {
      this.resources = []
    }
    this.uploadSingleFile(file)
    return false
  }

  uploadSingleFile(file: any) {
    this.uploading = true
    const handleUploadSuccess = (filename: any, originalFileName: any) => {
      this.uploading = false
      const newUrl = downloadHost + filename

      this.resources.push({
        name: originalFileName,
        url: newUrl
      })

      this.uploadedFiles.push(originalFileName)
    }

    Promise.all([getToken(), getMd5(file)]).then(([{ oss }, md5]) => {
      const originalFileName = file.name || ''
      let surfix = ''

      if (originalFileName.indexOf('.') > -1) {
        surfix = originalFileName.split('.').pop()
      }

      const newName = 'cguardian-resource/' + (surfix ? `${md5}.${surfix}` : md5)
      const newUploadingItem = {
        file,
        client: oss,
        tempCheckpoint: undefined,
        updateCheckpoint: (checkpoint: any) => {
          // console.log('checkpoint', checkpoint)
        },
        cb: (pgs: any) => {
          // console.log('pgs', pgs)
        },
        filename: newName,
        // 其他
        name: originalFileName,
        progress: '0%'
      }

      uploadAliyunOss(newUploadingItem).then((retData: any) => {
        handleUploadSuccess(retData.name, newUploadingItem.name)
      })
    })
  }

  private uploadingList = 0

  handleUploadChange(info) {
    let fileList = [...info.fileList]

    fileList = fileList.slice(-1)
    fileList = fileList.map((file) => {
      if (file.response) {
        file.url = file.response.url
      }
      return file
    })

    this.files = fileList
    this.uploadingList = fileList.length

    if (!fileList.length) {
      this.resources = []
    }
  }

  @Watch('uploadingList')
  handleUploadingListChange(val) {
    if (val === 0) {
      this.uploading = false
      this.resources = []
    }
  }

  previewFile(file) {
    const { name } = file
    const r = this.resources.find((item) => item.name === name)

    if (r) {
      const suffix = r.name.split('.')[1]

      if (['doc', 'docx'].includes(suffix)) {
        window.open(`https://vip.ow365.cn?i=22595&ssl=1&del=1&furl=${r.url}`)
      } else {
        window.open(r.url)
      }
    } else {
      this.$message.info('上传中')
    }
  }

  removeFile(file) {
    const { name } = file
    let index = ''
    this.resources.forEach((r, i) => {
      if (r.name === name) {
        index = i
      }
    })

    const uploadedIndex = this.uploadedFiles.indexOf(name)

    if (uploadedIndex >= 0) {
      this.uploadedFiles.splice(uploadedIndex, 1)
    } else {
      if (this.resources.length === this.uploadedFiles.length) {
        this.uploading = false
      }
    }

    if (typeof index === 'number') {
      this.resources.splice(index, 1)
    }

    return true
  }

  // 提交
  async handleSubmit(e) {
    e.preventDefault()
    this.form.validateFields(async (err, fieldsValue) => {
      if (err) return

      const values = {
        publish_at: fieldsValue['publish'].format('YYYY-MM-DD'),
        ...fieldsValue
      }

      if (this.uploadingList === 0) {
        this.resources = []
      }

      const h = this.$createElement

      this.$confirm({
        content: h('div', {}, [
          h('p', '1. 风控审核时间为9:00—18:00；'),
          h(
            'p',
            '2. 针对广告中出现的数据、统计资料、活动及价格等风控无法验证其真实性的内容，请提前咨询GR及法务等相关部门，业务方须确保其内容真实、准确；'
          ),
          h(
            'p',
            '3. 风控只涉及内容安全及广告法相关内容的审核，其它不在风控审核范畴的包括侵权等但不限于的内容请务必与相关部门核实，确保内容真实、准确，并符合相关规定。'
          )
        ]),
        centered: true,
        iconType: 'exclamation-circle',
        onOk: async () => {
          const options = {
            business_type: values.business_type,
            category: values.category,
            account_name: values.account_name.replace(/\s+/g, ''),
            title: values.title.replace(/\s+/g, ''),
            source: Number(values.source),
            publish_at: values.publish_at,
            operator: values.operator,
            resource_data: [this.resources[this.resources.length - 1]]
          }

          const res = await editResources(options)

          if (res.success) {
            this.resetForm()
            this.visible = false
            this.files = []
            this.$message.success('上传成功')
          }
        },
        onCancel() {}
      })
    })
  }

  // 重置表单
  resetForm() {
    this.form.resetFields([
      'business_type',
      'category',
      'account_name',
      'source',
      'operator',
      'title',
      'resource'
    ])
    this.form.setFieldsValue({
      publish: moment(new Date(), 'YYYY-MM-DD')
    })
    this.resources = []
    this.uploadingList = 0
  }
}
